import { makeUrl } from "../../../utils/makeUrl";

export interface NoteQueryParams {
	/**
	 * If provided, will fetch a single folder with the given ID. Otherwise, will fetch all folders (optionally filtered by folderId).
	 */
	readonly id?: string;
	/**
	 * If provided, will fetch all folders within the given folder. Ignored if `id` is provided.
	 */
	readonly folderId?: string | null;
	/**
	 * If true, will not perform any fetch and will return an empty array or null for data. Useful for cases where the folder data is not needed, such as when only performing mutations.
	 */
	readonly disabled?: boolean;
}

export const NOTES_URL_SEGMENT = "/users/notes";

/**
 * Generates a query key for fetching notes based on the provided parameters.
 * @param params - The parameters for the note query.
 * @returns An array representing the query key.
 */
export const getNotesKey = (params: NoteQueryParams) => [
	NOTES_URL_SEGMENT,
	params,
];

/**
 * Generates a URL for fetching notes based on the provided parameters.
 * @param params - The parameters for the note query.
 * @returns A string representing the URL.
 */
export const getNotesUrl = (params: NoteQueryParams) => {
	const url = makeUrl(NOTES_URL_SEGMENT);
	if (params.folderId) url.searchParams.set("folderId", params.folderId);
	else if (params.folderId === null) url.searchParams.set("folderId", "null");
	return url.pathname + url.search;
};
